// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

interface OrderTotalDisplaySharedStyles {
    gridContainer: GridContainerProps;
    styledHrGridItem?: GridItemProps;
    fullWidthGridItem?: GridItemProps;
    orderSummaryGridItem: GridItemProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
}

const label: TypographyPresentationProps = {
    size: 14,
    weight: fontConfig.weight.regular,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};

const value: TypographyPresentationProps = {
    size: 14,
    weight: fontConfig.weight.semiBold,
    color: "primary",
    css: css`
        letter-spacing: 0;
        line-height: 19px;
        margin-left: auto;
        text-align: right;
    `,
};

export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    gridContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 12px;
        `,
    },
    fullWidthGridItem: {
        width: 12,
    },
    styledHrGridItem: {
        width: 12,
    },
    orderSummaryGridItem: {
        width: 12,
    },
    titleText: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
    labelGridItem: {
        width: 7,
    },
    valueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        size: 16,
        lineHeight: "24px"
    },
    totalValue: {
        ...mergeWithCss(value, { size: 16, lineHeight: "22px" }),
    },
    styledHr: {
        css: css`
            width: 100%;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
            margin: 0;
        `,
    },
};
